document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-akt-mega-menu]').forEach(function (menu) {
    const triggers = menu.querySelectorAll('[data-akt-panel-trigger]');
    const panels = menu.querySelectorAll('[data-akt-panel]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        const panelId = trigger.getAttribute('data-akt-panel-trigger');

        triggers.forEach(function (item) {
          item.classList.remove('is-active');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        trigger.classList.add('is-active');

        const activePanel = menu.querySelector('[data-akt-panel="' + panelId + '"]');
        if (activePanel) {
          activePanel.classList.add('is-active');
        }
      });
    });
  });
});